import React from 'react'
import Slider from "rc-slider"
import clsx from 'clsx'

import {
    MdVolumeUp,
    MdVolumeMute
} from "react-icons/md"

const playerVolumeControl = ({
    volumeHandler,
    volume,
    muteStatus,
    muteHandler,
    classes,
    dropDownTrigger
}) => {

    let volumeIcon = <MdVolumeUp size="2rem" />
    if (muteStatus) {
        volumeIcon = <MdVolumeMute size="2rem" />
    }

    return (
        <div className={clsx("player-volume-control", {
            [classes]: !!classes
        })}>
            <ul id={dropDownTrigger} className='dropdown-content'>
                <li>
                    <a
                        onClick={() => muteHandler(!muteStatus)}
                    >
                        {volumeIcon}
                    </a>
                    <Slider
                        railStyle={{ background: "#ECF0F1", boderRadius: 10 }}
                        trackStyle={{ background: "#00B2FF" }}
                        handleStyle={{ background: "#00B2FF", border: "#00B2FF" }}
                        max={100}
                        onChange={value => volumeHandler(value)}
                        onAfterChange={value => volumeHandler(value)}
                        value={volume}
                    />
                </li>
            </ul>
            <a
                className="volume-dropdown-trigger"
                data-target={dropDownTrigger}
            >
                {volumeIcon}
            </a>
        </div>
    )
}

export default playerVolumeControl
